import { render, staticRenderFns } from "./DocumentsAntiCorruption.vue?vue&type=template&id=d8e3eb52"
import script from "./DocumentsAntiCorruption.vue?vue&type=script&lang=js"
export * from "./DocumentsAntiCorruption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports